export default "__VITE_ASSET__CWyxlkOK__"